import { BrandConfig } from './brand-config';

/** vehlogs – the brand of the app in every language except German. */
export const BRAND_VEHLOGS: BrandConfig = {
  id: 'vehlogs',
  brandName: 'vehlogs',
  webBaseUrl: 'https://vehlogs.com/ie',
  cookieDomain: '.vehlogs.com',
  supportEmail: 'support@vehlogs.com',
  noReplyEmail: 'noreply@vehlogs.com',
  savedPasswordDomain: 'vehlogs.com',
  appStoreUrl: 'https://apps.apple.com/ie/app/id6474508304',               // same app, English listing
  playStoreUrl: 'https://play.google.com/store/apps/details?id=de.kfzdoku', // same app, English listing
  // TODO (owner, B2): vehlogs logos. Until they exist, the KfzDoku files are used.
  logoPath: 'assets/images/kfzbook-logo-medium.jpg',
  smallLogoPath: 'assets/images/kfzbook-logo-mini.png',
  pdfLogoPath: 'assets/kfzbook-logo-medium.jpg',
  statusBarColor: '#2196F3',
  usualMarketId: 'ie',
};